// import store from '@/store/index.js'
// let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "学院",
            span: 8,
            placeholder: '请选择学院',
            model: "collegeId",
            type: "select",
            options:[],
            clearable: true,
        }
    ]
    const tableColumns = [
        {
            label: "系(院)",
            prop: "11",
            align: "center",
            show: true
        },
        {
            label: "普招生",
            prop: "22",
            align: "center",
            show:true,
            children: [
                {
                    label: "总人数",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
                {
                    label: "已报到人数",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
                {
                    label: "报到率",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
            ]
        },
        {
            label: "专升本",
            prop: "33",
            align: "center",
            show:true,
            children: [
                {
                    label: "总人数",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
                {
                    label: "已报到人数",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
                {
                    label: "报到率",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
            ]
        },
        {
            label: "全部",
            prop: "44",
            align: "center",
            show:true,
            children: [
                {
                    label: "总人数",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
                {
                    label: "已报到人数",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
                {
                    label: "报到率",
                    prop: "studentName",
                    align: "center",
                    show: true,
                },
            ]
        },
    ]

    return {
        searchItems,
        tableColumns
    }
}
